import React from 'react';
import OrderHistoryView from '../../../components/order/OrderHistoryView';

type Props = {
  /** Numeric order pronumber, or a "T"-prefixed template pronumber ("T110"). */
  pronumber: number | string;
};

const HistoryTab: React.FC<Props> = ({ pronumber }) => (
  <div className="h-full p-[5px] flex flex-col">
    <OrderHistoryView pronumber={pronumber} />
  </div>
);

export default HistoryTab;
